<template>
    <div class="login-wrap">
        <div class="logo-wrap">
            <img src="~@/image/icn-logo-b.svg">
            <p class="login-title">오마이플레이 로그인</p>
        </div>
        <div class="login-content-wrap user">
            <div>

                <div class="form-control-content-wrap">
                    <p class="title">이름</p>
                    <div class="form-control-content">
                        <input type="text" placeholder="입력해주세요" v-model="name">
                    </div>
                </div>
                <div class="form-control-content-wrap">
                    <p class="title">연락처</p>
                    <div class="form-control-content three">
                        <input type="text" placeholder="입력" v-model="firstPhone" @input="firstPhoneChangeFnc">
                        <input class="margin-item" type="text" placeholder="입력" v-model="secondPhone" @input="secondPhoneChangeFunc" ref="mobileSecond">
                        <input type="text" placeholder="입력" v-model="lastPhone" @input="lastPhoneChangeFunc" ref="mobileLast">
                    </div>
                </div>

                <div class="btn-wrap">
                    <div class="document-btn" @click="authNumberFunc" v-if="!authNumberCheck">인증번호받기</div>
                    <div class="document-btn disabled" @click="resetAuthNumberFunc" v-else>인증번호 다시 받기</div>
                    <p class="text">전화번호가 변경되었나요?<span @click="inquirieHerfFunc">문의하기</span></p>
                </div>
            </div>
        </div>

        <div class="login-content-wrap auth-number pb-3" v-if="authNumberCheck">
            <div>
                <div class="form-control-content-wrap">
                    <div class="float-content">
                        <p class="title fl">인증번호</p>
                        <p class="title fr">{{countDownMin}}:{{countDownSec}}</p>
                    </div>

                    <div class="form-control-content">
                        <input type="text" placeholder="인증번호를 입력해주세요" v-model="certKey" v-on:keyup.enter="checkAuthNumber">
                    </div>

                    <div class="btn-wrap">
                        <p class="text"><input type="checkbox" v-model="checkForAge"/><span>(필수) 만 14세 이상입니다.</span></p>
                        <p class="text"><input type="checkbox" v-model="checkForTermOfUse"/><span>(필수) <a href="https://ohmyplay.notion.site/4e71a2a7eda34e598c672b64db80e5d8?pvs=4"><span>이용약관</span></a>에 동의하십니까?</span></p>
                        <p class="text"><input type="checkbox" v-model="checkForPrivacy"/><span>(필수)<a href="https://www.ohmyplay.com/774ab16d-7784-4646-86d2-edc83713b490"><span>개인정보 취급방침</span></a>에 동의하십니까?</span></p>
                    </div>
                    <div class="document-btn mt-3" @click="checkAuthNumber">로그인</div>
                </div>
            </div>

        </div>

        <alert-modal :title="alertTitle" :content="alertContent" v-if="alertShow" @close="alertCloseFunc"></alert-modal>

    </div>
</template>
<script>
    import AlertModal from "../modal/AlertModal";
    export default{
        components: {AlertModal},
        data(){
            return{
                name: null,
                firstPhone: null,
                secondPhone: null,
                lastPhone: null,

                countDownMin: '05',
                countDownSec: '00',


                authNumberCheck: false,

                certKey: null,

                alertTitle: '알림',
                alertContent: '알림',
                alertShow: false,
                alertType: -1,

                interval: null
            }
        },
        methods: {
            resetAuthNumberFunc(){
                let validation = true
                let phone = `${this.firstPhone}-${this.secondPhone}-${this.lastPhone}`
                const regExp = /^\d{3}-\d{3,4}-\d{4}$/;


                if(!this.name){
                    validation = false
                    this.alertShowFunc('이름을 입력해주세요')

                }else if(!regExp.test(phone)){
                    validation = false
                    this.alertShowFunc('연락처 형식이 올바르지 않습니다.')

                }else{
                    const _this = this

                    phone = phone.replace(/-/g, '');
                    this.$store.dispatch('users/sendVerify', {mobile: phone}).then(res =>{
                        if(res.success){
                            clearInterval(_this.interval)
                            _this.alertShowFunc('인증번호가 재발송되었습니다. 제한시간내에 인증번호를 입력해주세요')
                            _this.authNumberCheck = true
                            _this.setTimer()
                        }else{
                            _this.alertShowFunc('오류가 발생했습니다. 잠시후 시도해주세요')
                        }
                    }).catch(err => {
                        // console.dir('users/sendVerify err =>')
                        // console.dir(err)
                        _this.alertShowFunc('오류가 발생했습니다. 잠시후 시도해주세요')
                    })

                }

            },
            setTimer(){

                const _vDate = new Date(new Date().getTime() + 5*60000)
                const _second = 1000
                const _minute = _second * 60
                const _hour = _minute * 60
                const _day = _hour * 60
                let timer

                const _this = this


                this.interval = setInterval(() => {
                    const now = new Date();
                    const distDt = _vDate - now
                    if(distDt < 0){
                        clearInterval(timer)
                        return ;
                    }

                    const days = Math.floor(distDt / _day)
                    const hours = Math.floor((distDt % _day) / _hour)
                    let min = Math.floor(distDt % _hour / _minute)
                    let sec = Math.floor(distDt % _minute / _second)

                    if(min < 10){
                        min = `0${min}`
                    }
                    if(sec < 10){
                        sec = `0${sec}`
                    }
                    _this.countDownMin = min
                    _this.countDownSec = sec


                })
            },
            authNumberFunc() {
                let validation = true
                let phone = `${this.firstPhone}-${this.secondPhone}-${this.lastPhone}`
                const regExp = /^\d{3}-\d{3,4}-\d{4}$/;


                if(!this.name){
                    validation = false
                    this.alertShowFunc('이름을 입력해주세요')

                }else if(!regExp.test(phone)){
                    validation = false
                    this.alertShowFunc('연락처 형식이 올바르지 않습니다.')

                }else{
                    const _this = this

                    phone = phone.replace(/-/g, '');

                    this.$store.dispatch('users/sendVerify', {mobile: phone}).then(res =>{
                        // console.dir(res)
                        if(res.success){
                            _this.alertShowFunc('인증번호가 발송되었습니다. 제한시간내에 인증번호를 입력해주세요')
                            _this.authNumberCheck = true
                            _this.setTimer()
                        }else{
                            _this.alertShowFunc('오류가 발생했습니다. 잠시후 시도해주세요')
                        }
                    }).catch(err => {
                        // console.dir('users/sendVerify err =>')
                        // console.dir(err)
                        _this.alertShowFunc('오류가 발생했습니다. 잠시후 시도해주세요')
                    })

                }

            },
            alertShowFunc(content){
                this.alertContent = content
                this.alertShow = true
            },
            checkAuthNumber(){
                const reg=/^[0-9]+$/; //숫자만 입력했는지 검증할 정규표현식

                const regExp = /^\d{3}-\d{3,4}-\d{4}$/;
                let phone = `${this.firstPhone}-${this.secondPhone}-${this.lastPhone}`
                const _this = this;
                //checkbox 확인하기
                console.log(this.checkForAge);
                console.log(this.checkForTermOfUse);
                console.log(this.checkForPrivacy);

                if(!this.checkForAge){
                    this.alertShowFunc('만 14세 이상이시면 체크해주세요.')
                    return false;
                }else if(!this.checkForTermOfUse){
                    this.alertShowFunc('이용약관 동의에 체크해주세요.')
                    return false;
                }else if(!this.checkForPrivacy){
                    this.alertShowFunc('개인정보활용 동의에 체크해주세요.')
                    return false;
                }
                if(!this.certKey){
                    this.alertShowFunc('인증번호를 입력해주세요')
                }else if(!reg.test(this.certKey)){
                    this.alertShowFunc('숫자만 입력해주세요')
                }else if(!regExp.test(phone)){
                    this.alertShowFunc('연락처 형식이 올바르지 않습니다.')
                }else{

                    phone = phone.replace(/-/g, '');
                    _this.$store.dispatch('users/login', {mobile: phone, certKey: this.certKey}).then(res => {
                        if(res.status === 0){
                            _this.alertShowFunc('인증번호가 일치하지 않습니다.')
                        }else if(res.status === 1){
                            _this.$router.replace('/')
                            // _this.$router.go(-1);
                        }else{
                            _this.alertType = 1
                            _this.alertShowFunc('로그인 정보가 없습니다. 회원가입 화면으로 이동합니다.')
                        }
                    }).catch(err => {
                        // console.dir('users/login err => ')
                        // console.dir(err)
                        _this.alertShowFunc('오류가 발생했습니다. 잠시후 시도해주세요')
                    })
                }

            },
            alertCloseFunc(){
                const phone = `${this.firstPhone}-${this.secondPhone}-${this.lastPhone}`
                if(this.alertType === 1){
                    this.$router.push(`/join?name=${this.name}&mobile=${phone}&certKey=${this.certKey}`)
                }else{

                }
                this.alertType = -1
                this.alertShow = false
            },
            firstPhoneChangeFnc(){
                this.firstPhone = this.onlyNumberReplaceFunc(this.firstPhone)
                this.firstPhone = this.firstPhone.substr(0,3)
                if(this.firstPhone.length === 3){
                    this.$refs.mobileSecond.focus()
                }
            },
            secondPhoneChangeFunc(){
                this.secondPhone = this.onlyNumberReplaceFunc(this.secondPhone)
                this.secondPhone = this.secondPhone.substr(0,4)
                if(this.secondPhone.length === 4){
                    this.$refs.mobileLast.focus()
                }
            },
            lastPhoneChangeFunc(){
                this.lastPhone = this.onlyNumberReplaceFunc(this.lastPhone)
                this.lastPhone = this.lastPhone.substr(0,4)
            },
            inquirieHerfFunc(){
                window.open('http://pf.kakao.com/_lJkxad ')
            }
        }
    }
</script>
